<div class="main shadow card">
    <div class="topContainer" style="height: 38%;">
        <div class="font-size:24px">{{facility_name}}</div>
        <!-- <span *ngIf="showIcon" (click)="editClicked()" style="margin-left:auto; cursor:pointer; margin-left:5px;"><i
                class="fa fa-pencil-square-o" style="color:#ED1556 ;" aria-hidden="true"></i></span> -->
    </div>
    <div class="middleContainer" style="height: 30%;">
        <div class="profileInfo">
            <div style="font-weight:500">Joined on</div>
            <div style="font-weight: 600;">{{created_at}}</div>
        </div>
        <div class="profileInfo">
            <div style="font-weight:500">Profile last updated on</div>
            <div style="font-weight: 600;">{{lastUpdatedAt}}</div>
        </div>
        <!-- <div class="profileInfo">
            <div style="font-weight:500;">Profile last updated by</div>
            <div style="width:100px; height:auto;  word-wrap: break-word; font-weight:600; text-align:end;">
                {{facility_name}}
            </div>
        </div> -->
    </div>
    <div class="bottomContainer" style="height: 32%;">
        <div style="font-size: 16px; font-weight:600">Organisation Profile</div>
        <div class="spinnerContainer">
            <div class="spinnerHolder">
                <mat-progress-spinner class="progressSpinner" [diameter]="50" [color]="color" [value]="value" width:60>
                </mat-progress-spinner>
                <div class="spinnerPercentText">{{value}}%</div>
            </div>
            <div class="textContainer">
                <div>Profile Completed</div>
                <!-- <div>Lorem ipsum dolor sit amet,</div> -->
            </div>
        </div>
    </div>
</div>